// extracted by mini-css-extract-plugin
module.exports = {"bottom-column-wapper":"gi","bottomColumnWapper":"gi","bottom-column-panel":"gj","bottomColumnPanel":"gj"};